import React, {Component} from 'react';
import {
    Button,
    Modal,
    Form,
} from 'semantic-ui-react';

import connect from "react-redux/es/connect/connect";
import {addCombo, listCombo} from "../../actions/ComboActions";
import {showToast} from "../../actions/ToastAction";
import {productPricesDialog} from "../../actions/ProductPricesDialogActions";
import BranchOfficeData from "../../data/BranchOfficeData";
import DynamicTable from "../extras/DynamicTable";
import ProductPricesData from "../../data/ProductPricesData";
import {dynamicTableAddOrUpdate, dynamicTableDelete} from "../../actions/DynamicTableDataAction";
import QuestionDialog from "../extras/QuestionDialog";

class ProductPricesDialog extends Component {

    constructor(props) {
        super(props);

        this.state = {
            table: {
                headers: ['Sucursal', 'Precio Venta', 'Acciones'],
                name: 'Precio',
                title: 'Precios',
                has_actions: true,
                edit: true,
                images: false,
                can_add: true,
                pagination: true,
                delete: true,
                url: '',
                values: ['id', 'branch_office', 'sale_price'],
                child_fields: [{branch_office:'name'}],
                money_fields: ['sale_price'],
                id: 'table_product_prices',
            },
            branch_offices: [],
            compound_error: false,
            quantity_error: false,
            data:{
                branch_office:'',
                sale_price:'',
                id: null,
                product: null
            },
            product_prices:[],
            loading: true,
            disabled_button:false,
            modal_dialog:false,
            sale_price_error: false
        };
        this.handleSubmitModal = this.handleSubmitModal.bind(this);
        this.delete = this.delete.bind(this);
    }

    componentWillReceiveProps(nextProps){
        if(nextProps.modal.id && nextProps.modal.id !== this.state.id){
            let table = this.state.table
            table.url = `product-prices/${nextProps.modal.id}`

            let data = this.state.data
            data.product = nextProps.modal.id
            this.setState({loading:true, table, data});
            this.initialFetch(nextProps.modal.id);
        }
    }

    async initialFetch(id) {
        let branch_offices = await BranchOfficeData.listAll();
        let data = this.state.data;
        data.branch_office = branch_offices[0].key
        this.setState({loading: false, branch_offices, data});
    }

    handleClose = () => {
        this.setState({
            id: null,
            loading: false,
        });
        this.props.productPricesDialog({
            is_open:false,
            loading:false,
            name:null,
            id:null
        });
    };

    handleCloseModalDialog = () => {
        this.setState({modal_dialog:false})
        this.cleanModalForm();
    }

    handleChange = (e, { name, value }) => {
        let data = this.state.data;
        data[name]= value;
        this.setState({data, compound_error:false, quantity_error:false});
    };

    callbackDynamicTable = (response) => {
        if(response.event === 'add'){
            this.setState({modal_dialog:true})
        }else if(response.event === 'edit'){
            console.log(response.data)
            let data = this.state.data
            data.id = response.data.id
            data.sale_price = response.data.sale_price
            data.branch_office = response.data.branch_office.id
            this.setState({modal_dialog:true, data})
        }else if(response.event === 'delete'){
            this.refs.deletePriceDialog.open('', response.data.id);
        }
    };

    delete(id) {
        ProductPricesData.delete(id, (res) => {
            if (res === null) {
                this.props.showToast({message: 'Precio borrado!', type: 'success'});
                this.props.dynamicTableDelete(id);
            } else {
                this.props.showToast({message: 'Tenemos un problema!', type: 'error'});
            }
        });
    };

    cleanModalForm(){
        let data = this.state.data
        data.sale_price = ''
        data.id = null
        this.setState({data})
    }

    handleSubmitModal(event) {
        event.preventDefault();
        if (this.state.data.sale_price === '') {
            this.setState({sale_price_error: true});
        } else {
            this.setState({disabled_button: true});
            let data = this.state.data
            if (data.id) {
                ProductPricesData.update(data, (res) => {
                    if (res.hasOwnProperty('id')) {
                        this.dispatchData(res, 'Precio Actualizado!');
                    }
                    else if (res.hasOwnProperty('error')) {
                        this.props.showToast({message: res.error, type: 'error'});
                        this.setState({disabled_button: false});
                    }
                    else {
                        this.props.showToast({message: 'Tenemos un problema!', type: 'error'});
                        this.setState({disabled_button: false});
                    }
                });
            } else {
                ProductPricesData.add(data, (res) => {
                    if (res !== null && res.hasOwnProperty('id')) {
                        this.dispatchData(res, 'Precio Agregado!');
                    }else if (res.hasOwnProperty('error')) {
                        this.props.showToast({message: res.error, type: 'error'});
                        this.setState({disabled_button: false});
                    } else {
                        this.props.showToast({message: 'Tenemos un problema!', type: 'error'});
                        this.setState({disabled_button: false});
                    }
                });
            }
        }
    };

    dispatchData(res, message){
        this.setState({disabled_button:false, modal_dialog:false})
        this.props.dynamicTableAddOrUpdate(res);
        this.cleanModalForm();
        this.props.showToast({message, type: 'success'});
    }

    render() {
        return (
            <div>
                <Modal open={this.props.modal.is_open} dimmer='inverted' size='small' onClose={this.handleClose}>
                    <Modal.Header>{`${this.props.modal.name} - Precios por sucursal`}</Modal.Header>
                    <Modal.Content image scrolling>
                        <Modal.Description>
                            <DynamicTable {...this.state.table} callbackDynamicTable={this.callbackDynamicTable}/>
                        </Modal.Description>
                    </Modal.Content>
                    <Modal.Actions>
                        <Button icon='x' labelPosition='left' onClick={this.handleClose} content="Cerrar"/>
                    </Modal.Actions>
                </Modal>

                <Modal open={this.state.modal_dialog} dimmer='inverted' size='mini' onClose={this.handleCloseModalDialog}>
                    <Modal.Header>{`Precio por sucursal`}</Modal.Header>
                    <Modal.Content>
                        <Modal.Description>
                            <Form widths='equal'>
                                <Form.Group>
                                    <Form.Select
                                        fluid options={this.state.branch_offices}
                                        onChange={this.handleChange}
                                        name='branch_office'
                                        value={this.state.data.branch_office}
                                        placeholder='Sucursal'
                                        label='Sucursal'
                                    />
                                </Form.Group>
                                <Form.Group>
                                    <Form.Input
                                        label='Precio de venta'
                                        placeholder='Precio de venta'
                                        type='number'
                                        name='sale_price'
                                        min={0}
                                        step={'.01'}
                                        value={this.state.data.sale_price}
                                        onChange={this.handleChange}
                                        error={this.state.sale_price_error}
                                    />
                                </Form.Group>
                            </Form>
                        </Modal.Description>
                    </Modal.Content>
                    <Modal.Actions>
                        <Button icon='x' labelPosition='left' onClick={this.handleCloseModalDialog} content="Cerrar"/>
                        <Button primary icon='save' labelPosition='left' disabled={this.state.disabled_button}
                                loading={this.state.disabled_button} onClick={this.handleSubmitModal}
                                content={this.state.data.id ? 'Actualizar' : 'Guardar'}/>
                    </Modal.Actions>
                </Modal>
                <QuestionDialog ref="deletePriceDialog" message="Borrar este precio" callbackConfirm={this.delete}/>
            </div>
        );
    }
}

function mapDispatchToProps(dispatch) {
    return {
        productPricesDialog(modal) {
            dispatch(productPricesDialog(modal))
        },
        listCombo(data){
            dispatch(listCombo(data))
        },
        dynamicTableAddOrUpdate(data){
            dispatch(dynamicTableAddOrUpdate(data))
        },
        dynamicTableDelete(data){
            dispatch(dynamicTableDelete(data))
        },
        addCombo(data){
            dispatch(addCombo(data))
        },
        showToast(alert) {
            dispatch(showToast(alert));
        },
    }
}

function mapStateToProps(state) {
    return {
        modal: state.get('product_prices_dialog'),
    };
}


export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ProductPricesDialog)


// WEBPACK FOOTER //
// ./src/components/inventories/ProductPricesDialog.js